import React from "react"

import SidebarList from "../../components/Navbar/Components/SidebarList"
const Drawer = ({ isDrawerOpen = true }) => {
  return (
    <aside
      className={`hidden transform lg:block  ${isDrawerOpen ? "translate-x-0" : "hidden -translate-x-full !w-0 !min-w-0 invisible"
        } transition-transform duration-300 ease-in-out lg:min-w-[280px] xl:min-w-[351px]`}
    >
      <SidebarList />
    </aside>
  )
}

export default Drawer;
